<template>
  <div id="app">
    <RouterView />
  </div>
</template>

<script setup>
// 主应用入口
</script>

<style>
#app {
  font-family: 'Microsoft YaHei', sans-serif;
  min-height: 100vh;
  background-color: #f9fcff;
}
</style>